import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DataDisplay from '../components/DataDisplay';

const mapStateToProps = (state, ownProps) => {
	let file = state.fileContents[ownProps.fileId];

	return {
		fileId: ownProps.fileId,
		title: ownProps.title,
		data: file.tableRows,
		headers: file.headers,
		isLoading: file.isLoading,
		filename: file.filename,
		isLoaded: file.isLoaded,
		headersExist: file.headersExist,
		headerSelection: file.selectedColumns,
		formula: file.formula,
		firstRow: file.firstRow,
		axisLabel: file.axisLabel,
	}
};

const mapDispatchToProps = dispatch => {
    return {dispatch};
};

const ConnectedDataDisplay = connect(
    mapStateToProps,
    mapDispatchToProps
)(DataDisplay);

ConnectedDataDisplay.propTypes = {
	fileId: PropTypes.string,
	title: PropTypes.string,
}

export default ConnectedDataDisplay;



// WEBPACK FOOTER //
// ./src/containers/ConnectedDataDisplay.js